import React from "react";

const VideoIcon = ({ color = "#000000", size = "20" }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 13 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.125 6.26962L4.94391 7.25L6.625 4.75"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11 11H2.25C1.25 11 1 10.1669 1 9.75V2.25C1 1.91848 1.1317 1.60054 1.36612 1.36612C1.60054 1.1317 1.91848 1 2.25 1H8.5C8.83152 1 9.14946 1.1317 9.38388 1.36612C9.6183 1.60054 9.75 1.91848 9.75 2.25V6M11 11C10.5831 11 9.75 10.75 9.75 9.75V6M11 11C12 11 12.25 10.1669 12.25 9.75V6H9.75"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default VideoIcon;
